import React, { useRef, useEffect } from 'react'
import Chart, { ChartData } from 'chart.js/auto'
import styled from 'styled-components'
import { SimulationsResponse } from '../../../types/API'

interface ExecutionsDelayedChartProps {
  data: SimulationsResponse
}

const ExecutionsDelayedChart: React.FC<ExecutionsDelayedChartProps> = ({ data }) => {
  const lineData: Record<string, number> = {}
  let totalizer = 0

  for (const [date, { executionDelayed }] of Object.entries(data)) {
    if (lineData[date]) {
      lineData[date] += executionDelayed
    } else {
      lineData[date] = executionDelayed
    }
    if (executionDelayed) {
      totalizer += executionDelayed
    }
  }

  const processData = () => {
    const allDateLabels = Object.keys(data)
    allDateLabels.sort()
    return { dateLabels: allDateLabels }
  }

  const { dateLabels } = processData()

  const chartData: ChartData<'line', number[], string> = {
    labels: dateLabels,
    datasets: [
      {
        type: 'line',
        fill: true,
        label: 'Delayed Executions',
        yAxisID: 'tasks-y-axis',
        data: Object.values(lineData),
        borderColor: 'rgb(20,217,252)',
        backgroundColor: 'rgba(25,168,211,0.82)',
        pointBackgroundColor: 'rgb(20,217,252)',
        tension: 0.8,
        pointRadius: 7,
        pointHoverRadius: 10,
        pointHoverBackgroundColor: 'rgb(20,217,252)',
        pointHoverBorderColor: 'rgb(20,217,252)',
      },
    ],
  }

  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const chartRef = useRef<Chart | null>(null)

  const createChart = () => {
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext('2d')
      if (ctx) {
        chartRef.current = new Chart(ctx, {
          type: 'bar',
          data: chartData,
          options: {
            responsive: true,
            scales: {
              'tasks-y-axis': {
                beginAtZero: true,
              },
            },
          },
        })
      }
    }
  }

  const destroyChart = () => {
    if (chartRef.current) {
      chartRef.current.destroy()
    }
  }

  useEffect(() => {
    createChart()

    return () => {
      destroyChart()
    }
  }, [data])

  return (
    <>
      <h1>Delayed Executions {totalizer > 0 && <Tot>Total: {totalizer}</Tot>}</h1>
      <div>
        <canvas ref={canvasRef} />
      </div>
    </>
  )
}

const Tot = styled.p`
  font-size: 14px;
  display: inline-flex;
  background: rgb(20, 217, 252);
  padding: 5px 10px;
  border-radius: 22px;
  margin-left: 18px;
`

export default ExecutionsDelayedChart
